import { render, staticRenderFns } from "./PaymentsDetail.vue?vue&type=template&id=272cb380"
import script from "./PaymentsDetail.vue?vue&type=script&lang=js"
export * from "./PaymentsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports